export default __webpack_public_path__ + "static/media/030-lantern.dc866bdd.svg";